<template>
  <div class="club-base-layout">
    <div :class="baseLayoutContentClassList">
      <div
        :class="useCenteredSlotData ? 'align-center' : ''"
        class="club-base-layout__body justify-center"
      >
        <slot name="club-base-layout-body" />
      </div>
      <div class="club-base-layout__footer">
        <slot name="club-base-layout-prepend-footer" />
        <slot name="club-base-layout-footer">
          <div class="text-body-2 text-info--text text-center">
            Если возникли вопросы, звоните
            <br v-if="isMobileDevice">
            <!-- Табуляция специально таким образом расставлена -->
            <!-- Чтобы подчеркивание ссылки не выходило за пределы слова -->
            <a
              href="tel:88007073129"
              class="text-body-2 text-info--text"
            >8 (800) 707-31-29</a>
            — поможем разобраться
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ClubStyleData,
  ClubCommonData,
  ClubGlobalData,
} from 'www/vue_components/common/Club/mixins'

import fireConfetti from 'www/vue_components/common/AppointmentPage/functions/fireConfetti'

export default {
  name: 'ClubBaseLayout',
  mixins: [
    ClubStyleData,
    ClubCommonData,
    ClubGlobalData,
  ],
  props: {
    useCenteredSlotData: {
      type: Boolean,
      default: false,
    },
    useConfettiImageBackground: {
      type: Boolean,
      default: false,
    },
    useDesktopContentIndents: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseLayoutContentClassList() {
      let classListResult = 'club-base-layout__content'

      if (this.isMobileDevice) {
        classListResult += ' club-base-layout__content_mobile'
      }

      if (this.useDesktopContentIndents) {
        classListResult += ' py-6'
      }

      return classListResult
    },
  },
  watch: {
    useConfettiImageBackground(value) {
      if (value) {
        fireConfetti()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.club-base-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  background-position: 0 0;
  background-size: contain;
  background-color: $ui-kit-bg-gray-0;

  &__content {
    width: 100%;
    height: 700px;
    margin: 0 auto;
    max-width: 520px;
    box-sizing: inherit;
    display: flex;
    flex-direction: column;
  }

  &__content_mobile {
    height: 100%;
    width: inherit;
    overflow-y: auto;
    padding: 16px 8px;
    box-sizing: inherit;
  }

  &__body {
    flex-grow: 1;
    display: flex;
    width: inherit;
  }

  &__footer {
    flex-grow: 0;
    width: inherit;
  }
}
</style>
